import { module } from "angular";
import type { Observable } from "rxjs";
import { map } from "rxjs/operators";
import moment from "moment-timezone";

import type { IHttpService } from "App/Modules/Services";
import type {
    SiteScheduleException,
    IResponse,
    SiteScheduleExceptionDelete,
    SiteScheduleExceptionDeleteResponse,
    SiteScheduleExceptionInsert,
    SiteScheduleExceptionInsertResponse,
} from "../../Models";
import type { ISiteScheduleExceptionsRepository } from "./ISiteScheduleExceptionsRepository";

export class SiteScheduleExceptionsRepository implements ISiteScheduleExceptionsRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getScheduleExceptions(siteId: string): Observable<IResponse<SiteScheduleException[]>> {
        return this.httpService.get<SiteScheduleException[]>(`sites/${siteId}/scheduleExceptions`).pipe(
            map((response) => {
                response.data.forEach((ex) => {
                    ex.dtStart = moment.utc(ex.dtStart);
                    ex.dtStop = moment.utc(ex.dtStop);
                });
                return response;
            }),
        );
    }

    public addScheduleException(
        siteId: string,
        data: SiteScheduleExceptionInsert,
    ): Observable<IResponse<SiteScheduleExceptionInsertResponse>> {
        return this.httpService
            .post<SiteScheduleExceptionInsertResponse>(`sites/${siteId}/scheduleExceptions`, data)
            .pipe(
                map((response) => {
                    if (response.data) {
                        response.data.added?.forEach((e) => SiteScheduleExceptionsRepository.adjustDateTimes(e));
                        response.data.deleted?.forEach((e) => SiteScheduleExceptionsRepository.adjustDateTimes(e));
                        response.data.updated?.forEach((e) => SiteScheduleExceptionsRepository.adjustDateTimes(e));
                    }
                    return response;
                }),
            );
    }

    public removeScheduleException(
        siteId: string,
        data: SiteScheduleExceptionDelete,
    ): Observable<IResponse<SiteScheduleExceptionDeleteResponse>> {
        return this.httpService
            .patch<SiteScheduleExceptionDeleteResponse>(`sites/${siteId}/scheduleExceptions`, data)
            .pipe(
                map((response) => {
                    if (response.data) {
                        response.data.deleted?.forEach((e) => SiteScheduleExceptionsRepository.adjustDateTimes(e));
                        response.data.updated?.forEach((e) => SiteScheduleExceptionsRepository.adjustDateTimes(e));
                    }
                    return response;
                }),
            );
    }

    private static adjustDateTimes(exception: SiteScheduleException) {
        if (!exception) {
            return;
        }
        exception.dtStart = moment.utc(exception.dtStart);
        exception.dtStop = moment.utc(exception.dtStop);
    }
}

module("mmRepositories").service("mmSiteScheduleExceptionsRepository", SiteScheduleExceptionsRepository);
